import * as React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import { Step } from '../../../BaseComponents/Stepbar/types';
import { Money as MoneyType } from '../../../Money/types';
import { Money } from '../../../Money';
import { useTheme } from '../../../theme';
import { expandIcon } from '../../Icons';

interface Props {
	className?: string;
	currentStep: number;
	steps: Step[];
	totalPrice: MoneyType;
	isOpen: boolean;
	onToggle: () => void;
}

const StepbarHeader: React.FC<Props> = ({ className, currentStep, steps, totalPrice, isOpen, onToggle }) => {
	const { t } = useTranslation('MobileStepbar');
	const { StepbarHeader: css } = useTheme('MobileStepbar');

	return (
		<div
			className={cn(className, css.header, { [css.header_zeroPrice]: totalPrice.amount === 0 })}
			onClick={onToggle}
		>
			{currentStep >= 0 && steps[currentStep]?.label && (
				<div className={css.stepIndex}>
					{currentStep + 1}/{steps.length}:
					<span className={css.stepIndex__label}>{steps[currentStep].label}</span>
				</div>
			)}

			<div className={css.price}>
				<div className={css.price__wrapper}>
					<span className={css.price_title}>{t('Total')}</span>
					<Money money={totalPrice} />
				</div>

				<span className={cn(css.expand, { [css.expand_open]: isOpen })}>{expandIcon}</span>
			</div>
		</div>
	);
};

export default StepbarHeader;
